import { eventBus } from './event-bus'
import { Notification } from './types'

export const notify = (params: Omit<Notification, 'id'>) => {
  eventBus.$emit('notify', params)
}
